window.initSizeCalculator = function initSizeCalculator(root) {
  if (!root) return;

  // Prevent double init
  root.querySelectorAll('[data-size-calculator]').forEach((wrap) => {
    if (wrap.dataset.inited === '1') return;
    wrap.dataset.inited = '1';

    const isNmzV1 = wrap.getAttribute('data-is-nmz-v1') === 'true';

    const defaultSizeTable = {
      "70": { "B": "S", "C": "S", "D": "S" },
      "75": { "B": "S", "C": "S", "D": "M", "DD/E": "M" },
      "80": { "B": "M", "C": "M", "D": "M", "DD/E": "L", "DDD/F": "L" },
      "85": { "B": "M", "C": "M", "D": "L", "DD/E": "L", "DDD/F": "XL", "G": "XL" },
      "90": { "B": "M", "C": "L", "D": "L", "DD/E": "XL", "DDD/F": "XL", "G": "XL", "H": "2XL" },
      "95": { "C": "L", "D": "XL", "DD/E": "XL", "DDD/F": "XL", "G": "2XL", "H": "2XL", "I": "3XL" },
      "100": { "C": "L", "D": "XL", "DD/E": "XL", "DDD/F": "2XL", "G": "2XL", "H": "3XL", "I": "3XL" },
      "105": { "D": "XL", "DD/E": "2XL", "DDD/F": "2XL", "G": "3XL", "H": "3XL", "I": "3XL" },
      "110": { "DD/E": "2XL", "DDD/F": "3XL", "G": "3XL", "H": "3XL" },
      "115": { "DD/E": "2XL", "DDD/F": "3XL", "G": "3XL", "H": "3XL" },
      "120": { "DDD/F": "3XL", "G": "3XL" }
    };

    const nmzV1SizeTable = {
      "75":  { "C": "M",  "D": "M",  "E": "M",  "F": "M"  },
      "80":  { "C": "L",  "D": "L",  "E": "L",  "F": "L"  },
      "85":  { "C": "XL", "D": "XL", "E": "XL", "F": "XL" },
      "90":  { "C": "2XL","D": "2XL","E": "2XL","F": "2XL"},
      "95":  { "C": "3XL","D": "3XL","E": "3XL","F": "3XL"},
      "100": { "C": "4XL","D": "4XL","E": "4XL","F": "4XL"},
      "105": { "C": "5XL","D": "5XL","E": "5XL","F": "5XL"},
      "110": { "C": "6XL","D": "6XL","E": "6XL","F": "6XL"}
    };

    const table = isNmzV1 ? nmzV1SizeTable : defaultSizeTable;

    const bandSel  = wrap.querySelector('[data-role="band"]');
    const cupSel   = wrap.querySelector('[data-role="cup"]');
    const resultEl = wrap.querySelector('[data-role="result"]');

    if (!bandSel || !cupSel || !resultEl) return;

    function fillCups(band) {
      cupSel.innerHTML = '<option value="">Wählen...</option>';
      resultEl.textContent = '';

      const row = table[band];
      if (!row) return;

      Object.keys(row).forEach((cup) => {
        const opt = document.createElement('option');
        opt.value = cup;
        opt.textContent = cup;
        cupSel.appendChild(opt);
      });
    }

    bandSel.addEventListener('change', () => fillCups(bandSel.value));
    cupSel.addEventListener('change', () => {
      const band = bandSel.value;
      const cup  = cupSel.value;
      resultEl.textContent = (table[band] && table[band][cup]) ? table[band][cup] : '';
    });

    if (bandSel.value) fillCups(bandSel.value);
  });
};